export default __webpack_public_path__ + "static/media/3stepweightloss@2x.ea339e58.jpg";